import Tippy from '@tippyjs/react';
import React, { useState } from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import CircularProgress from '@material-ui/core/CircularProgress';
import PaginationItem from './PaginationItem';
import {
  BootstrapPaginationDots,
  BootstrapPaginationFirst,
  BootstrapPaginationLast,
  BootstrapPaginationButton,
} from './styles';

interface PaginationProps {
  rowsCount: number;
  limit?: number;
  currentPage?: number;
  updatePage?: () => void;
  tela: number;
  onPageChange: (page: number) => void;
  hasButtonUpdate?: boolean;
}
const siblingsCount = 1;

function generatePagesArray(from: number, to: number) {
  return [...new Array(to - from)]
    .map((_, index) => {
      return from + index + 1;
    })
    .filter((page) => page > 0);
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const {
    rowsCount,
    limit = 10,
    currentPage = 1,
    onPageChange,
    updatePage,
    hasButtonUpdate = true,
  } = props;

  const [loading, setLoading] = useState(false);

  let lastPage = Math.ceil(rowsCount / limit);
  if (lastPage === 0) {
    lastPage = 1;
  }
  const previousPages =
    currentPage > 1
      ? generatePagesArray(currentPage - 1 - siblingsCount, currentPage - 1)
      : [];

  const nextPages =
    currentPage < lastPage
      ? generatePagesArray(
          currentPage,
          Math.min(currentPage + siblingsCount, lastPage),
        )
      : [];

  async function refetchData() {
    setLoading(true);
    if (updatePage) {
      updatePage();
    }
    setLoading(false);
  }
  return (
    <BootstrapPagination>
      {hasButtonUpdate && (
        <Tippy
          placement="left"
          content={`Atualizar dados da página ${currentPage}`}
          arrow
          animation="scale"
        >
          <span style={{ display: 'inline-flex' }}>
            <BootstrapPaginationButton
              onClick={async () => {
                await refetchData();
              }}
            >
              {loading ? (
                <CircularProgress size={15} style={{ color: '#ffffff' }} />
              ) : (
                'Atualizar'
              )}
            </BootstrapPaginationButton>
          </span>
        </Tippy>
      )}

      <Tippy placement="top" content="Voltar" arrow animation="scale">
        <span style={{ display: 'inline-flex' }}>
          <BootstrapPaginationFirst
            disabled={currentPage - 1 < 1}
            onClick={() =>
              onPageChange(currentPage - 1 <= 0 ? 1 : currentPage - 1)
            }
          >
            <BsChevronLeft />
          </BootstrapPaginationFirst>
        </span>
      </Tippy>

      {currentPage > 1 + siblingsCount && (
        <>
          <Tippy
            placement="top"
            content={`Página ${1}`}
            arrow
            animation="scale"
          >
            <span style={{ display: 'inline-flex' }}>
              <PaginationItem onPageChange={() => onPageChange(1)} page={1} />
            </span>
          </Tippy>
          {currentPage > 2 + siblingsCount && (
            <BootstrapPaginationDots
              style={{ marginTop: '10px', cursor: 'default' }}
            >
              ...
            </BootstrapPaginationDots>
          )}
        </>
      )}

      {previousPages.length > 0 &&
        previousPages.map((page) => {
          return (
            <Tippy
              placement="top"
              key={page}
              content={`Página ${page}`}
              arrow
              animation="scale"
            >
              <span style={{ display: 'inline-flex' }}>
                <PaginationItem
                  onPageChange={() => onPageChange(page)}
                  page={page}
                  key={page}
                />
              </span>
            </Tippy>
          );
        })}
      <Tippy
        placement="top"
        content={`Página ${currentPage}`}
        arrow
        animation="scale"
      >
        <span style={{ display: 'inline-flex' }}>
          <PaginationItem
            onPageChange={() => onPageChange(currentPage)}
            page={currentPage}
            isCurrent
          />
        </span>
      </Tippy>

      {nextPages.length > 0 &&
        nextPages.map((page) => {
          return (
            <Tippy
              placement="top"
              key={page}
              content={`Página ${page}`}
              arrow
              animation="scale"
            >
              <span style={{ display: 'inline-flex' }}>
                <PaginationItem
                  onPageChange={() => onPageChange(page)}
                  page={page}
                  key={page}
                />
              </span>
            </Tippy>
          );
        })}

      {currentPage + siblingsCount < lastPage && (
        <>
          {currentPage + 1 + siblingsCount < lastPage && (
            <BootstrapPaginationDots
              style={{ marginTop: '10px', cursor: 'default' }}
            >
              ...
            </BootstrapPaginationDots>
          )}
          <Tippy
            placement="top"
            content={`Página ${lastPage}`}
            arrow
            animation="scale"
          >
            <span style={{ display: 'inline-flex' }}>
              <PaginationItem
                onPageChange={() => onPageChange(lastPage)}
                page={lastPage}
              />
            </span>
          </Tippy>
        </>
      )}
      <Tippy placement="top" content="Avançar" arrow animation="scale">
        <span style={{ display: 'inline-flex' }}>
          <BootstrapPaginationLast
            disabled={currentPage + 1 > lastPage}
            onClick={() =>
              onPageChange(
                currentPage + 1 >= lastPage ? lastPage : currentPage + 1,
              )
            }
          >
            <BsChevronRight />
          </BootstrapPaginationLast>
        </span>
      </Tippy>
    </BootstrapPagination>
  );
};

export default Pagination;
